import React, { useMemo } from "react";
import { PieChart } from "../../../components/ui/Graph";
import PropTypes from "prop-types";

const PieRCSDashboard = ({
  data = {
    i_campaigns: 0,
    i_api: 0,
  },
  loading,
}) => {
  const createArr = useMemo(() => {
    const arr = [];
    arr.push(Number(data?.i_campaigns));
    arr.push(Number(data?.i_api));
    return arr;
  }, [data]);


  return (
    <PieChart
      title="Distribución de RCS por tipo de envío"
      labels={["Campañas", "API"]}
      callbackLabel="RCS"
      dataSets={createArr}
      label="No. de RCS"
      loading={loading}
    />
  );
};

PieRCSDashboard.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default PieRCSDashboard;
